import { DefaultValue } from "recoil";

export const guardIsRecoilDefaultValue = (
  candidate: unknown,
): candidate is DefaultValue => {
  if (candidate instanceof DefaultValue) {
    return true;
  }

  return false;
};
